// @flow

import type { SalesMember } from 'statsradio/modules/salesMembers/domain/SalesMember';

export const PropositionSummaryTimeRanges = {
  LAST_30_DAYS: 'LAST_30_DAYS',
  THIS_MONTH: 'THIS_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  THIS_QUARTER: 'THIS_QUARTER',
  LAST_QUARTER: 'LAST_QUARTER',
};

export type PropositionSummaryTimeRangeValues = $Values<typeof PropositionSummaryTimeRanges>;

export class PropositionSummaryQuery {

  timeRange: PropositionSummaryTimeRangeValues;
  selectedSalesMember: SalesMember;

  constructor({ timeRange, selectedSalesMember }: { timeRange: PropositionSummaryTimeRangeValues, selectedSalesMember: SalesMember }) {
    this.timeRange = timeRange;
    this.selectedSalesMember = selectedSalesMember;
  }

  asQueryParam() {
    return {
      range: this.timeRange,
      salesMember: this.selectedSalesMember
        ? this.selectedSalesMember.reference
        : undefined,
    };
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/domain/PropositionSummaryQuery.js